var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { connect } from "react-redux";
import { BlockRefresh, BlockNavigationActions } from "@irati/utils/history/routing";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import Modal from "@irati/ui/src/Modal";
import { H4, Body } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import Flex from "@irati/ui/src/Flex";
var OnLeaveCustomisation = /** @class */ (function (_super) {
    __extends(OnLeaveCustomisation, _super);
    function OnLeaveCustomisation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onLeave = function () {
            var _a = _this.props, unblockNavigation = _a.unblockNavigation, trackLeave = _a.trackLeave;
            trackLeave();
            unblockNavigation(true);
        };
        _this.hideModal = function () {
            var unblockNavigation = _this.props.unblockNavigation;
            unblockNavigation(false);
        };
        return _this;
    }
    OnLeaveCustomisation.prototype.render = function () {
        var _a = this.props, block = _a.block, show = _a.show;
        return (React.createElement(BlockRefresh, { block: block },
            React.createElement(Modal, { show: show, onHide: this.hideModal },
                React.createElement(H4, null,
                    React.createElement(FormattedMessage, { id: "account.customisation.interests.modalHeader" })),
                React.createElement(Body, null,
                    React.createElement(FormattedMessage, { id: "account.customisation.interests.modalText" })),
                React.createElement(Flex, { justifyContent: "flex-end", marginTop: 2 },
                    React.createElement(Button, { tertiary: true, onClick: this.hideModal },
                        React.createElement(FormattedMessage, { id: "account.customisation.interests.modalCancel" })),
                    React.createElement(Button, { primary: true, onClick: this.onLeave, marginLeft: 2 },
                        React.createElement(FormattedMessage, { id: "account.customisation.interests.modalContinue" }))))));
    };
    return OnLeaveCustomisation;
}(Component));
var mapStateToProps = function (_a) {
    var blockNavigation = _a.blockNavigation;
    return {
        show: blockNavigation.show
    };
};
var actions = function (dispatch) {
    return {
        unblockNavigation: function (bool) { return dispatch(BlockNavigationActions.unblock(bool)); }
    };
};
export default injectIntl(connect(mapStateToProps, actions)(OnLeaveCustomisation));
